import { Dialog } from '@primer/react/experimental';
import { Button } from '@primer/react';
import styled, { StyledComponent } from 'styled-components';

/** Render an empty header to suppress Primer's default dialog header bar */
export const EmptyHeader = () => null;

// Override Primer Dialog to remove default header bar and apply consistent border-radius.
// Explicit StyledComponent type annotation is required because Primer's polymorphic
// Dialog type can't be inferred portably (TS2742).
export const ModalDialog: StyledComponent<typeof Dialog, any, object> = styled(Dialog)`
  &[role='dialog'] {
    border-radius: var(--border-radius__xl);
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space__xl);
  padding: var(--space__2xl);
  text-align: center;
`;

export const ModalIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: var(--font-size__2xl);
  font-weight: var(--font-weight__bold);
`;

export const ModalDescription = styled.p`
  margin: 0;
  font-size: var(--font-size__md);
  color: var(--color__gray-500);
  line-height: 1.5;
`;

/* Fix: Primer primary buttons render their visible border via box-shadow, not CSS border */
// Explicit StyledComponent type annotation is required because Primer's polymorphic
// Button type can't be inferred portably (TS2742).
export const ModalButton: StyledComponent<typeof Button, any, object> = styled(Button)`
  border: none;
  box-shadow: none;
  &:focus,
  &:focus-visible {
    outline: none;
    box-shadow: none;
  }
`;
